import { useMutation, useQueryClient } from "@tanstack/react-query";
import { DocumentContentService } from "../../../../services/document/document-content.service";
import { notification } from "antd";
interface IVariable {
  id: string;
  body: any;
}

export const useUpdateDocumentContent = () => {
  const queryClient = useQueryClient();

  const { mutate, ...restMutation } = useMutation({
    mutationFn: ({ id, body }: { id: string; body: any }) => {
      return DocumentContentService.update(id, body);
    },
  });

  const updateDocumentContent = (
    vars: IVariable,
    options?: {
      onSuccess?: (r: any) => void;
      successText?: string;
      errorText?: string;
    },
  ) => {
    mutate(vars, {
      onSuccess(response: any) {
        queryClient.invalidateQueries({
          queryKey: ["document-content"],
        });
        window.location.hash = `title-${response.Id}`;
        if (options?.onSuccess) options.onSuccess(response);
      },
      onError() {
        notification.error({
          message: "Thất bại",
          description: options?.errorText ?? `Thêm thất bại.`,
        });
      },
    });
  };

  return { mutate, updateDocumentContent, ...restMutation };
};
